export default {
	API_URL: 'https://api-seft.infinitum-ti.com/api',
	OAPI_URL: 'https://api-seft.infinitum-ti.com/oapi',
	// API_URL: 'http://localhost:2383/api',
	// OAPI_URL: 'http://localhost:2383/oapi',
}
